import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { EmployeeOfficeNotesBO } from './employee-agreementlist.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeAgreementlistService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }

  getClientIdlist(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeeDetailsRelation/GetEmployeeClientList?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getLov(paramsData: URLSearchParams): Observable<any> {
    let url = "api/Lov/GetLovDropDown?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  getTemplatelist(): Observable<any> {
    let url = "api/EmployeeAgreement/GetTemplateNamesListForAgency?";
    return this.http.get<any>(url, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  saveOfficeNotes(officeNote: EmployeeOfficeNotesBO): Observable<any> {
    let url = "api/EmployeeAgreement/SaveEmployeeOfficeNotes";
    return this.http.post(url, officeNote, { observe: 'response', responseType: "text" }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )


  }
  getEmpDocumentList(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeeAgreement/GetEmpDocumentPdfDetails?";
    return this.http.get(url + params, { observe: 'response', responseType: "text" }).pipe(map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  getEmployeeBio(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeeDetailsRelation/GetEmployeeList?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  getClientBio(params: URLSearchParams): Observable<any> {
    let url = "api/EmployeeDetailsRelation/GetClientDetail?";
    return this.http.get<any>(url + params, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }


  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  DeleteEMpAggrementInfo(paramsData: URLSearchParams): Observable<any> {
    let url = "api/EmployeeAgreement/DeleteEmployeeAgrement?";
    return this.http.delete<number>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }



}
